import { FormlySelectOption } from "@common/interfaces/formly";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";



export namespace ObjectHelpers {

  export const purgeUndefined = (obj: Object) => {
    for (const key in obj) {
      if (obj[key] === undefined) {
        delete obj[key];
      }
    }
  };
  /**
   * Check if there is at least one property that is not null, undefined or empty string ''
   * Useful to check forms
   */
  export const hasOnlyEmptyValues = (obj: Object) => {
    for (const key in obj) {
      if (
        obj[key] !== undefined &&
        obj[key] !== "" &&
        obj[key] !== null &&
        !(Array.isArray(obj[key]) && obj[key].length === 0)
      ) {
        return false;
      }
    }
    return true;
  };

  export const hasProps = (obj: object) => {
    return Object.keys(obj).length > 0;
  };

  export function enumMembersName(): FormlySelectOption[] {
    const result: FormlySelectOption[] = [];
    for (const value in Object.keys(InterfaceName)) {
      if (typeof InterfaceName[value] !== "string") {
        continue;
      }
      result.push({ id: value, name: InterfaceName[Number(value)] });
    }
    return result;
  }

  export function interfacesToOptions(
    items: InterfaceName[]
  ): FormlySelectOption[] {
    return items.map((item) => ({
      id: item.toString(),
      name: InterfaceName[item]?.replace(/_/g, " "),
    }));
  }

  function replace(
    str: string,
    toReplace: string,
    replaceWith: string
  ): string {
    return str.split(toReplace).join(replaceWith);
  }

  export function hasNestedObject(object: Object): boolean {
    let hasNested: boolean = false;
    for (let value of Object.values(object)) {
      if (
        value !== null &&
        typeof value === "object" &&
        Array.isArray(value) === false
      ) {
        hasNested = true;
      }
    }
    return hasNested;
  }

  export function arrEquals(arr1: any[], arr2: any[]): boolean {
    if ((arr1 && !arr2) || (!arr1 && arr2) || (!arr1 && !arr2)) {
      return false;
    }
    if (arr1.length !== arr2.length) {
      return false;
    }
    if (arr1.length === 0 && arr2.length === 0) {
      return true;
    }
    return arr1.every((el) =>
      arr2.some((el2) => {
        if (typeof el !== typeof el2) {
          return false;
        }
        if (Array.isArray(el) && Array.isArray(el2)) {
          return arrEquals(el, el2);
        }
        if (typeof el === "object") {
          return objEquals(el, el2);
        }
        //el === el2
      })
    );
  }

  export function objEquals(obj1: {}, obj2: {}): boolean {
    if ((obj1 && !obj2) || (!obj1 && obj2) || (!obj1 && !obj2)) {
      return false;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (typeof obj2[key] !== typeof obj1[key]) {
        return false;
      }
      if (Array.isArray(obj2[key]) && Array.isArray(obj1[key])) {
        return arrEquals(obj2[key], obj1[key]);
      }
      if (typeof obj2[key] === "object") {
        return objEquals(obj2[key], obj1[key]);
      }
      if (obj2[key] !== obj1[key]) {
        return false;
      }
    }
  }

  type Groupable = { [key: string | number]: any };
  /**
   * Raggruppa un array di oggetti in base al valore di una proprietà
   */
  export function groupBy<T extends Groupable>(array: T[], key: keyof T) {
    return array.reduce((acc, curr) => {
      if (typeof curr[key] !== "string") {
        throw new Error("Property value is not a string");
      }
      (acc[curr[key]] = acc[curr[key]] || []).push(curr);
      return acc;
    }, {} as { [key: string | number]: T[] });
  }
}

